import { Component } from 'react';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { connect } from 'react-redux';
import { parse } from 'hub-http/helpers/params';
import * as AppActions from '../actions/AppActions';
import { DEBUG_OPTION_KEYS } from '../constants';
import { debug } from '../utils/env';
import UniversalEditorContainer from './UniversalEditorContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const mapDispatchToProps = {
  setOptions: AppActions.setOptions
};
class UniversalEditorAppContainer extends Component {
  //TODO remove default props once page PR is merged

  componentDidMount() {
    const {
      setOptions
    } = this.props;
    setDocumentTitle('theme-previewer.htmlTitle');
    const queryParams = parse(window.location.search.slice(1));
    const debugOptions = DEBUG_OPTION_KEYS.reduce((final, key) => {
      final[key] = queryParams[key] === 'true';
      return final;
    }, {});
    let redirectUrl = queryParams['redirectUrl'];
    if (redirectUrl && !redirectUrl.startsWith('/')) {
      redirectUrl = `/${redirectUrl}`;
    }
    const businessUnitId = this.props.businessUnitId || 0;
    setOptions(Object.assign({}, debugOptions, {
      debugMode: !!debug(),
      fromAppName: this.props.fromAppName,
      businessUnitId: businessUnitId ? parseInt(businessUnitId, 10) : undefined,
      redirectUrl: redirectUrl && `${window.location.origin}${redirectUrl}`,
      testMode: false
    }));
  }
  render() {
    return /*#__PURE__*/_jsx(UniversalEditorContainer, Object.assign({}, this.props));
  }
}
UniversalEditorAppContainer.defaultProps = {
  handleSaveThemeSettingsBuffer: () => {},
  reloadIframePreview: () => {}
};
export default connect(null, mapDispatchToProps)(UniversalEditorAppContainer);